import { render } from "./Service.vue?vue&type=template&id=02b78721"
import script from "./Service.vue?vue&type=script&lang=ts"
export * from "./Service.vue?vue&type=script&lang=ts"
script.render = render

export default script